import { render } from "./SignInTest.vue?vue&type=template&id=d5105ea8"
import script from "./SignInTest.vue?vue&type=script&lang=js"
export * from "./SignInTest.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__